import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.reverse";
import "regenerator-runtime/runtime";

var _marked = /*#__PURE__*/regeneratorRuntime.mark(_callee2);

/*
 * Copyright (c) 2019 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
// Return to a previous view by name
import { takeLatest, select, put } from 'redux-saga/effects';
import { go } from 'connected-react-router';
import { WORKFLOW_RETURN_TO_VIEW, setIgnoreNextPathChange } from '../actions';
import { getWorkflowViews } from '../../selectors'; // Why is this function out here instead of inside the generator function? For some
// unknown reason, the presence of "findIndex" causes an exception in older versions
// of Firefox. Go figure.

var getViewIndex = function getViewIndex(views, viewName) {
  return views.findIndex(function (view) {
    return view.viewName === viewName;
  });
};

export default function _callee2() {
  return regeneratorRuntime.wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return takeLatest(WORKFLOW_RETURN_TO_VIEW, /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
            var viewName, views, viewIndex;
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    viewName = _ref.viewName;
                    _context.next = 3;
                    return select(getWorkflowViews);

                  case 3:
                    views = _context.sent;
                    viewIndex = getViewIndex(views.reverse(), viewName);

                    if (!(viewIndex > 0)) {
                      _context.next = 10;
                      break;
                    }

                    _context.next = 8;
                    return put(setIgnoreNextPathChange(false));

                  case 8:
                    _context.next = 10;
                    return put(go(-1 * viewIndex));

                  case 10:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked);
}